import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import { styles } from './NavItem.styles'

const Item = styled.div`
  ${styles.base};
`

const NavItem = ({
  children,
  className,
  active,
  type = 'primary',
  ...rest
}) => {
  return (
    <Item className={cn(className, { active })} type={type} {...rest}>
      {children}
    </Item>
  )
}

export default NavItem
